export type ShellSplashVariant = 'blue' | 'light'

export type ShellSplashTheme = Readonly<{
  variant: ShellSplashVariant
  background: string
  logoFill: string
}>

const themes: Record<ShellSplashVariant, Omit<ShellSplashTheme, 'variant'>> = {
  blue: {
    background: '#0061aa',
    logoFill: '#ffffff',
  },
  light: {
    background: '#ffffff',
    logoFill: '#0061aa',
  },
}

export function resolveShellSplashVariant(raw: string | undefined): ShellSplashVariant {
  return raw === 'light' ? 'light' : 'blue'
}

export function buildDefaultShellSplashVariant(): ShellSplashVariant {
  return resolveShellSplashVariant(import.meta.env.VITE_SHELL_SPLASH_VARIANT)
}

export function shellSplashTheme(variant: ShellSplashVariant = buildDefaultShellSplashVariant()): ShellSplashTheme {
  const colors = themes[variant]
  return { variant, ...colors }
}
